import { DateTime } from "luxon";
import type { LoadedVault, LoadedVaultWithPnl, } from "../loaded";



export const applySynthTransactions = (vault: LoadedVaultWithPnl): LoadedVaultWithPnl => {

	if(!["BBOR1"].includes(vault.symbol)) {
		return vault;
	}

	const {
		transactions,
		denomination: {
			decimals,
		}
	} = vault;

	if(transactions.length === 0) {
		return vault;
	}

	const shares = vault.transactions.reduce((acc, t) => (
		t.trxn_type === "DEPOSIT" ? acc + BigInt(t.shares) :
		t.trxn_type === "WITHDRAW" ? acc - BigInt(t.shares) :
		acc
	), 0n).toString();

	const hasTransfer = Number(shares) / (10**decimals) > 0.0001;
	
	const finalizer = Object.assign({}, vault.transactions[0], {
		trxn_type: "WITHDRAW",
		block: Infinity,
		created: DateTime.fromISO("2025-08-21T17:30:00"),
		scheduled_time: DateTime.now().toMillis(),
		claimed_time: DateTime.now().toMillis(),
		finalized: true,
		shares,
		amount_brkt: "5540",
		brkt_claimed: true,
		hash: "0",
		amount_eq: 0,
		pnl: "0",
		share_price_usd: 2619.09,
		price_btc: 0,
		price_eth: 0,
		brkteth_conv: 0,
		transaction_hash: "0",
		wallet_address: "0",
		vault_address: "0",
	})

	vault.transactions = hasTransfer ? [ finalizer, ...vault.transactions ] : vault.transactions;
	
	return vault;
}


export const applySynthTransactions2 = ( vault: LoadedVault ): LoadedVault => {

	if(!["BBOR1"].includes(vault.symbol)) {
		return vault;
	}

	const {
		transactions,
		denomination: {
			decimals,
		}
	} = vault;

	if(transactions.length === 0) {
		return vault;
	}

	const shares = vault.transactions.reduce((acc, t) => (
		t.trxn_type === "DEPOSIT" ? acc + BigInt(t.shares) :
		t.trxn_type === "WITHDRAW" ? acc - BigInt(t.shares) :
		acc
	), 0n).toString();

	
	const hasTransfer = Number(shares) / (10**decimals) > 0.0001;

	const finalizer = Object.assign({}, vault.transactions[0], {
		trxn_type: "TRANSFER",
		block: Infinity,
		created: DateTime.fromISO("2025-08-21T17:30:00"),
		scheduled_time: DateTime.now().toMillis(),
		claimed_time: DateTime.now().toMillis(),
		finalized: true,
		shares,
		amount_brkt: BigInt(Math.floor(2619.09 * (10**decimals))).toString(),
		brkt_claimed: true,
		hash: "0",
		amount_eq: 0,
		pnl: "0",
		share_price_usd: 0,
		price_btc: 0,
		price_eth: 0,
		brkteth_conv: 0,
		transaction_hash: "0",
		wallet_address: "0",
		vault_address: "0",
	})

	vault.transactions = hasTransfer ? [ finalizer, ...vault.transactions ] : vault.transactions;


	return vault;
	

}
